export const MONTHS = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

export const roles = [
  {
    value: "maker",
    label: "Maker",
  },
  {
    value: "checker",
    label: "Checker",
  },
];

export const Period = [
  { value: 0, label: "PERIOD-1" },
  { value: 1, label: "PERIOD-2" },
  { value: 2, label: "PERIOD-3" },
  { value: 3, label: "PERIOD-4" },
  { value: 4, label: "PERIOD-5" },
  { value: 5, label: "PERIOD-6" },
  { value: 6, label: "PERIOD-7" },
  { value: 7, label: "PERIOD-8" },
  { value: 8, label: "PERIOD-9" },
  { value: 9, label: "PERIOD-10" },
  { value: 10, label: "PERIOD-11" },
  { value: 11, label: "PERIOD-12" },
];

export const GLFileType = [
  { value: "Oracle", label: "Oracle" },
  { value: "SAP", label: "SAP" },
  { value: "Tally", label: "Tally" },
];

export const recordsFilterOptions = [
  { value: "maker", label: "Maker" },
  { value: "checker", label: "Checker" },
];

export const ComparisonOptions = [
  { value: "mom", label: "MOM" },
  { value: "qoq", label: "QOQ" },
  { value: "yoy", label: "YOY" },
];

export const QuarterOption = [
  { value: 0, label: "Quarter 1" },
  { value: 1, label: "Quarter 2" },
  { value: 2, label: "Quarter 3" },
  { value: 3, label: "Quarter 4" },
];

export const TypeOptions = [
  { value: "prime", label: "Prime" },
  { value: "non_prime", label: "Non Prime" },
];

export const QuarterMonthsMap: Record<number, number[]> = {
  0: [0, 1, 2],
  1: [3, 4, 5],
  2: [6, 7, 8],
  3: [9, 10, 11],
};

// ───────────────────────────────────────────────────────────
// Company Config overhaul — reference data for Profile / Tax & Secretarial.
// ───────────────────────────────────────────────────────────

// A practical, actively-traded set rather than the full ISO 4217 list --
// Base Currency is one dropdown for the company's own reporting currency,
// not a full FX rate table.
export const CURRENCY_OPTIONS = [
  { value: "USD", label: "USD - US Dollar" },
  { value: "EUR", label: "EUR - Euro" },
  { value: "GBP", label: "GBP - British Pound" },
  { value: "INR", label: "INR - Indian Rupee" },
  { value: "JPY", label: "JPY - Japanese Yen" },
  { value: "CNY", label: "CNY - Chinese Yuan" },
  { value: "AUD", label: "AUD - Australian Dollar" },
  { value: "CAD", label: "CAD - Canadian Dollar" },
  { value: "CHF", label: "CHF - Swiss Franc" },
  { value: "SGD", label: "SGD - Singapore Dollar" },
  { value: "HKD", label: "HKD - Hong Kong Dollar" },
  { value: "AED", label: "AED - UAE Dirham" },
  { value: "SAR", label: "SAR - Saudi Riyal" },
  { value: "ZAR", label: "ZAR - South African Rand" },
  { value: "BRL", label: "BRL - Brazilian Real" },
  { value: "MXN", label: "MXN - Mexican Peso" },
  { value: "SEK", label: "SEK - Swedish Krona" },
  { value: "NOK", label: "NOK - Norwegian Krone" },
  { value: "DKK", label: "DKK - Danish Krone" },
  { value: "NZD", label: "NZD - New Zealand Dollar" },
  { value: "KRW", label: "KRW - South Korean Won" },
  { value: "IDR", label: "IDR - Indonesian Rupiah" },
  { value: "MYR", label: "MYR - Malaysian Ringgit" },
  { value: "THB", label: "THB - Thai Baht" },
  { value: "PHP", label: "PHP - Philippine Peso" },
  { value: "VND", label: "VND - Vietnamese Dong" },
  { value: "PLN", label: "PLN - Polish Zloty" },
  { value: "TRY", label: "TRY - Turkish Lira" },
  { value: "RUB", label: "RUB - Russian Ruble" },
  { value: "EGP", label: "EGP - Egyptian Pound" },
  { value: "NGN", label: "NGN - Nigerian Naira" },
  { value: "KES", label: "KES - Kenyan Shilling" },
  { value: "PKR", label: "PKR - Pakistani Rupee" },
  { value: "BDT", label: "BDT - Bangladeshi Taka" },
  { value: "LKR", label: "LKR - Sri Lankan Rupee" },
];

// How large numbers should be grouped for display -- not a computed value,
// just a display preference stored per company.
export const NUMBER_FORMAT_OPTIONS = [
  { value: "standard", label: "Standard (1,000,000)" },
  { value: "millions", label: "Millions (1,000,000 -> 1.00M)" },
  { value: "lakhs", label: "Lakhs/Crores (1,00,00,000)" },
];

// How dates render in Reveal AI Insights (DimeRec/DimeXplain). "dd/mm/yyyy"
// is the fallback wherever a company hasn't chosen one.
export const DATE_FORMAT_OPTIONS = [
  { value: "dd/mm/yyyy", label: "DD/MM/YYYY (31/12/2025)" },
  { value: "mm/dd/yyyy", label: "MM/DD/YYYY (12/31/2025)" },
  { value: "mon_dd_yyyy", label: "Mon DD, YYYY (Dec 31, 2025)" },
];

// Common IANA zones spanning every major offset -- not exhaustive of every
// city in the tz database, but covers every distinct UTC offset a company
// is likely to be in.
export const TIMEZONE_OPTIONS = [
  { value: "UTC", label: "UTC" },
  { value: "America/Los_Angeles", label: "America/Los Angeles (PT)" },
  { value: "America/Denver", label: "America/Denver (MT)" },
  { value: "America/Chicago", label: "America/Chicago (CT)" },
  { value: "America/New_York", label: "America/New York (ET)" },
  { value: "America/Sao_Paulo", label: "America/Sao Paulo" },
  { value: "America/Mexico_City", label: "America/Mexico City" },
  { value: "Atlantic/Reykjavik", label: "Atlantic/Reykjavik" },
  { value: "Europe/London", label: "Europe/London" },
  { value: "Europe/Paris", label: "Europe/Paris (CET)" },
  { value: "Europe/Berlin", label: "Europe/Berlin" },
  { value: "Europe/Moscow", label: "Europe/Moscow" },
  { value: "Africa/Cairo", label: "Africa/Cairo" },
  { value: "Africa/Johannesburg", label: "Africa/Johannesburg" },
  { value: "Africa/Lagos", label: "Africa/Lagos" },
  { value: "Asia/Jerusalem", label: "Asia/Jerusalem" },
  { value: "Asia/Riyadh", label: "Asia/Riyadh" },
  { value: "Asia/Dubai", label: "Asia/Dubai" },
  { value: "Asia/Karachi", label: "Asia/Karachi" },
  { value: "Asia/Kolkata", label: "Asia/Kolkata (IST)" },
  { value: "Asia/Kathmandu", label: "Asia/Kathmandu" },
  { value: "Asia/Dhaka", label: "Asia/Dhaka" },
  { value: "Asia/Bangkok", label: "Asia/Bangkok" },
  { value: "Asia/Jakarta", label: "Asia/Jakarta" },
  { value: "Asia/Singapore", label: "Asia/Singapore" },
  { value: "Asia/Hong_Kong", label: "Asia/Hong Kong" },
  { value: "Asia/Shanghai", label: "Asia/Shanghai" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo" },
  { value: "Asia/Seoul", label: "Asia/Seoul" },
  { value: "Australia/Perth", label: "Australia/Perth" },
  { value: "Australia/Sydney", label: "Australia/Sydney" },
  { value: "Pacific/Auckland", label: "Pacific/Auckland" },
];

// Company registration identifier types across jurisdictions -- CIN (India),
// CVR (Denmark), DIW/KT (Nordics), CRN (UK), SEC (US), ORG (generic).
export const COMPANY_ID_TYPE_OPTIONS = [
  { value: "CIN", label: "CIN - Corporate Identity Number (India)" },
  { value: "CVR", label: "CVR - Central Business Register (Denmark)" },
  { value: "DIW", label: "DIW" },
  { value: "KT", label: "KT" },
  { value: "CRN", label: "CRN - Company Registration Number (UK)" },
  { value: "SEC", label: "SEC - Registration Number (US)" },
  { value: "ORG", label: "ORG - Organization Number" },
  { value: "OTHER", label: "Other" },
];

// Tax registration identifier types -- a company can hold more than one at
// once (see the Tax & Secretarial "+Add Tax Identifier" list).
export const TAX_ID_TYPE_OPTIONS = [
  { value: "PAN", label: "PAN - Permanent Account Number (India)" },
  { value: "GSTIN", label: "GSTIN - Goods & Services Tax ID (India)" },
  { value: "VAT_ID", label: "VAT ID - Value Added Tax ID" },
  { value: "TIN", label: "TIN - Tax Identification Number" },
  { value: "EIN", label: "EIN - Employer Identification Number (US)" },
  { value: "UTR", label: "UTR - Unique Taxpayer Reference (UK)" },
  { value: "CST", label: "CST - Central Sales Tax" },
  { value: "ORG", label: "ORG - Organization Tax Number" },
  { value: "TAX", label: "TAX - Generic Tax Number" },
  { value: "VST", label: "VST" },
  { value: "BE", label: "BE" },
  { value: "ES", label: "ES" },
  { value: "OTHER", label: "Other" },
];

// Accounting standards a company can report under, worldwide. "Other / Not
// Listed" is a deliberate fallback -- without it, a jurisdiction the list
// doesn't cover would make this field impossible to fill in at all.
export const ACCOUNTING_STANDARD_OPTIONS = [
  { value: "AS", label: "AS - Indian Accounting Standards (pre Ind AS)" },
  { value: "IND_AS", label: "Ind AS - Indian Accounting Standards (converged)" },
  { value: "IFRS", label: "IFRS" },
  { value: "UK_IFRS", label: "UK IFRS" },
  { value: "UK_GAAP", label: "UK GAAP" },
  { value: "US_GAAP", label: "US GAAP" },
  { value: "SWISS_GAAP_FER", label: "Swiss GAAP FER" },
  { value: "GERMAN_GAAP", label: "German GAAP (HGB)" },
  { value: "FRENCH_GAAP", label: "French GAAP (PCG)" },
  { value: "AUS_AAS", label: "Australian Accounting Standards" },
  { value: "CANADIAN_ASPE", label: "Canadian ASPE" },
  { value: "CANADIAN_IFRS", label: "Canadian IFRS" },
  { value: "SINGAPORE_FRS", label: "Singapore FRS" },
  { value: "HK_IFRS", label: "Hong Kong IFRS (HKFRS)" },
  { value: "JAPANESE_GAAP", label: "Japanese GAAP" },
  { value: "CHINESE_AS", label: "Chinese Accounting Standards" },
  { value: "BRAZILIAN_GAAP", label: "Brazilian GAAP" },
  { value: "SOUTH_AFRICAN_IFRS", label: "South African IFRS" },
  { value: "OTHER", label: "Other / Not Listed" },
];

// Reminder-only -- not enforced. Options match the day-of-the-following-
// month examples from the spec.
export const DEFAULT_CLOSE_DAY_OPTIONS = [
  { value: 5, label: "5th of the next month" },
  { value: 7, label: "7th of the next month" },
  { value: 15, label: "15th of the next month" },
];

export const COUNTRY_OPTIONS = [
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Albania", label: "Albania" },
  { value: "Algeria", label: "Algeria" },
  { value: "Andorra", label: "Andorra" },
  { value: "Angola", label: "Angola" },
  { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
  { value: "Argentina", label: "Argentina" },
  { value: "Armenia", label: "Armenia" },
  { value: "Australia", label: "Australia" },
  { value: "Austria", label: "Austria" },
  { value: "Azerbaijan", label: "Azerbaijan" },
  { value: "Bahamas", label: "Bahamas" },
  { value: "Bahrain", label: "Bahrain" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Barbados", label: "Barbados" },
  { value: "Belarus", label: "Belarus" },
  { value: "Belgium", label: "Belgium" },
  { value: "Belize", label: "Belize" },
  { value: "Benin", label: "Benin" },
  { value: "Bhutan", label: "Bhutan" },
  { value: "Bolivia", label: "Bolivia" },
  { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
  { value: "Botswana", label: "Botswana" },
  { value: "Brazil", label: "Brazil" },
  { value: "Brunei", label: "Brunei" },
  { value: "Bulgaria", label: "Bulgaria" },
  { value: "Burkina Faso", label: "Burkina Faso" },
  { value: "Burundi", label: "Burundi" },
  { value: "Cabo Verde", label: "Cabo Verde" },
  { value: "Cambodia", label: "Cambodia" },
  { value: "Cameroon", label: "Cameroon" },
  { value: "Canada", label: "Canada" },
  { value: "Central African Republic", label: "Central African Republic" },
  { value: "Chad", label: "Chad" },
  { value: "Chile", label: "Chile" },
  { value: "China", label: "China" },
  { value: "Colombia", label: "Colombia" },
  { value: "Comoros", label: "Comoros" },
  { value: "Congo (Congo-Brazzaville)", label: "Congo (Congo-Brazzaville)" },
  { value: "Costa Rica", label: "Costa Rica" },
  { value: "Cote d'Ivoire", label: "Cote d'Ivoire" },
  { value: "Croatia", label: "Croatia" },
  { value: "Cuba", label: "Cuba" },
  { value: "Cyprus", label: "Cyprus" },
  { value: "Czechia", label: "Czechia" },
  { value: "Democratic Republic of the Congo", label: "Democratic Republic of the Congo" },
  { value: "Denmark", label: "Denmark" },
  { value: "Djibouti", label: "Djibouti" },
  { value: "Dominica", label: "Dominica" },
  { value: "Dominican Republic", label: "Dominican Republic" },
  { value: "Ecuador", label: "Ecuador" },
  { value: "Egypt", label: "Egypt" },
  { value: "El Salvador", label: "El Salvador" },
  { value: "Equatorial Guinea", label: "Equatorial Guinea" },
  { value: "Eritrea", label: "Eritrea" },
  { value: "Estonia", label: "Estonia" },
  { value: "Eswatini", label: "Eswatini" },
  { value: "Ethiopia", label: "Ethiopia" },
  { value: "Fiji", label: "Fiji" },
  { value: "Finland", label: "Finland" },
  { value: "France", label: "France" },
  { value: "Gabon", label: "Gabon" },
  { value: "Gambia", label: "Gambia" },
  { value: "Georgia", label: "Georgia" },
  { value: "Germany", label: "Germany" },
  { value: "Ghana", label: "Ghana" },
  { value: "Greece", label: "Greece" },
  { value: "Grenada", label: "Grenada" },
  { value: "Guatemala", label: "Guatemala" },
  { value: "Guinea", label: "Guinea" },
  { value: "Guinea-Bissau", label: "Guinea-Bissau" },
  { value: "Guyana", label: "Guyana" },
  { value: "Haiti", label: "Haiti" },
  { value: "Honduras", label: "Honduras" },
  { value: "Hong Kong", label: "Hong Kong" },
  { value: "Hungary", label: "Hungary" },
  { value: "Iceland", label: "Iceland" },
  { value: "India", label: "India" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Iran", label: "Iran" },
  { value: "Iraq", label: "Iraq" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Italy", label: "Italy" },
  { value: "Jamaica", label: "Jamaica" },
  { value: "Japan", label: "Japan" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Kiribati", label: "Kiribati" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { value: "Laos", label: "Laos" },
  { value: "Latvia", label: "Latvia" },
  { value: "Lebanon", label: "Lebanon" },
  { value: "Lesotho", label: "Lesotho" },
  { value: "Liberia", label: "Liberia" },
  { value: "Libya", label: "Libya" },
  { value: "Liechtenstein", label: "Liechtenstein" },
  { value: "Lithuania", label: "Lithuania" },
  { value: "Luxembourg", label: "Luxembourg" },
  { value: "Madagascar", label: "Madagascar" },
  { value: "Malawi", label: "Malawi" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Maldives", label: "Maldives" },
  { value: "Mali", label: "Mali" },
  { value: "Malta", label: "Malta" },
  { value: "Marshall Islands", label: "Marshall Islands" },
  { value: "Mauritania", label: "Mauritania" },
  { value: "Mauritius", label: "Mauritius" },
  { value: "Mexico", label: "Mexico" },
  { value: "Micronesia", label: "Micronesia" },
  { value: "Moldova", label: "Moldova" },
  { value: "Monaco", label: "Monaco" },
  { value: "Mongolia", label: "Mongolia" },
  { value: "Montenegro", label: "Montenegro" },
  { value: "Morocco", label: "Morocco" },
  { value: "Mozambique", label: "Mozambique" },
  { value: "Myanmar", label: "Myanmar" },
  { value: "Namibia", label: "Namibia" },
  { value: "Nauru", label: "Nauru" },
  { value: "Nepal", label: "Nepal" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Nicaragua", label: "Nicaragua" },
  { value: "Niger", label: "Niger" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "North Korea", label: "North Korea" },
  { value: "North Macedonia", label: "North Macedonia" },
  { value: "Norway", label: "Norway" },
  { value: "Oman", label: "Oman" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Palau", label: "Palau" },
  { value: "Palestine", label: "Palestine" },
  { value: "Panama", label: "Panama" },
  { value: "Papua New Guinea", label: "Papua New Guinea" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Peru", label: "Peru" },
  { value: "Philippines", label: "Philippines" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Qatar", label: "Qatar" },
  { value: "Romania", label: "Romania" },
  { value: "Russia", label: "Russia" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
  { value: "Saint Lucia", label: "Saint Lucia" },
  { value: "Saint Vincent and the Grenadines", label: "Saint Vincent and the Grenadines" },
  { value: "Samoa", label: "Samoa" },
  { value: "San Marino", label: "San Marino" },
  { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "Senegal", label: "Senegal" },
  { value: "Serbia", label: "Serbia" },
  { value: "Seychelles", label: "Seychelles" },
  { value: "Sierra Leone", label: "Sierra Leone" },
  { value: "Singapore", label: "Singapore" },
  { value: "Slovakia", label: "Slovakia" },
  { value: "Slovenia", label: "Slovenia" },
  { value: "Solomon Islands", label: "Solomon Islands" },
  { value: "Somalia", label: "Somalia" },
  { value: "South Africa", label: "South Africa" },
  { value: "South Korea", label: "South Korea" },
  { value: "South Sudan", label: "South Sudan" },
  { value: "Spain", label: "Spain" },
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "Sudan", label: "Sudan" },
  { value: "Suriname", label: "Suriname" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Syria", label: "Syria" },
  { value: "Taiwan", label: "Taiwan" },
  { value: "Tajikistan", label: "Tajikistan" },
  { value: "Tanzania", label: "Tanzania" },
  { value: "Thailand", label: "Thailand" },
  { value: "Timor-Leste", label: "Timor-Leste" },
  { value: "Togo", label: "Togo" },
  { value: "Tonga", label: "Tonga" },
  { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
  { value: "Tunisia", label: "Tunisia" },
  { value: "Turkey", label: "Turkey" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Tuvalu", label: "Tuvalu" },
  { value: "Uganda", label: "Uganda" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "United States", label: "United States" },
  { value: "Uruguay", label: "Uruguay" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Vanuatu", label: "Vanuatu" },
  { value: "Vatican City", label: "Vatican City" },
  { value: "Venezuela", label: "Venezuela" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Yemen", label: "Yemen" },
  { value: "Zambia", label: "Zambia" },
  { value: "Zimbabwe", label: "Zimbabwe" },
];
